export default __webpack_public_path__ + "static/media/Polygontop.e5bb4235.svg";